export const ORDERDAD_COLUMN_LABELS: Record<string, string> = {
  order_company: 'Order Company',
  order_division: 'Order Division',
  order_number: 'Order Number',
  back_order_level: 'Back Order Level',
  line_number: 'Line Number',
  description: 'Description',
  supplier: 'Supplier',
  actual_cost_override: 'Actual Cost Override',
  core_cost_override: 'Core Cost Override',
  claim_number: 'Claim Number',
  purchase_order_number: 'Purchase Order Number',
  po_line_number: 'P/O Line Number',
  original_order_number: 'Original Order Number',
  original_back_order_level: 'Original Back Order Level',
  original_line_number: 'Original Line Number',
  requisition_number: 'Requisition Number',
  customer_po_number: 'Customer P/O Number',
  original_confirm_date: 'Original Confirm Date',
  confirm_quantity: 'Confirm Quantity',
  confirmed_by_userid: 'Confirmed By User',
  confirmed_on_system_date: 'Confirmed On System Date',
  alt_unit_of_measure: 'Alt Unit of Measure',
  alt_uom_conversion_factor: 'Alt UOM Conversion Factor',
  qty_ordered_in_alt: 'Qty Ordered in Alt',
  qty_shipped_in_alt: 'Qty Shipped in Alt',
  override_agreement_user: 'Override Agreement User',
  override_agreement_date: 'Override Agreement Date',
  override_agreement_flag: 'Override Agreement Flag',
  custom_use: 'Custom Use',
  po_company: 'P/O Company',
  po_division: 'P/O Division',
  po_location: 'P/O Location',
  po_type: 'P/O Type',
  edi_po_line_number: 'EDI P/O Line Number',
  edi_850_stock_uom: 'EDI 850 Stock UOM',
  edi_850_pricing_uom: 'EDI 850 Pricing UOM',
  edi_transaction_id: 'EDI Transaction ID',
  lot_item_number: 'Lot Item Number',
};

export const ORDERDAD_COLUMN_KEYS = Object.keys(ORDERDAD_COLUMN_LABELS);

export const ORDERDAD_BUILTIN_FILTER_COLUMNS = new Set<string>([
  'order_company',
  'order_division',
  'order_number',
  'supplier',
  'claim_number',
  'custom_use',
]);

export const ORDERDAD_CURRENCY_FIELDS = new Set<string>([
  'actual_cost_override',
  'core_cost_override',
]);
